import * as React from "react";
import { cn } from "../lib/utils.ts";

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  icon?: React.ReactNode;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ title, description, action, icon, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-[var(--color-border)] p-8 text-center",
          className,
        )}
        role="status"
        aria-live="polite"
        {...props}
      >
        {icon && (
          <div className="grid h-12 w-12 place-items-center rounded-full bg-[var(--color-accent-soft)] text-[var(--color-accent)]">
            {icon}
          </div>
        )}
        <h3 className="text-base font-semibold">{title}</h3>
        {description && (
          <p className="max-w-md text-sm text-[var(--color-muted-foreground)]">{description}</p>
        )}
        {action && <div className="pt-2">{action}</div>}
      </div>
    );
  },
);
EmptyState.displayName = "EmptyState";
